import React from "react"

import { withPrefix } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/modules/seo"
import MError from "../components/modules/m_error"

const NotFoundPage = () => (
  <Layout pageType="news">
    <SEO title="404: Not found" />
    <MError
      status="404"
      headline="Artikel nicht gefunden"
      buttonLabel="Zurück zur Startseite"
      buttonLink={withPrefix("/")}
    >
      <React.Fragment>
        Die von Ihnen gewählte Adresse/URL ist auf unserem Server nicht bzw.
        nicht mehr vorhanden. Möglicherweise haben Sie einen veralteten Link
        bzw. ein altes Bookmark verwendet. Versuchen Sie, den von Ihnen
        gewünschten Inhalt, über unsere Startseite oder die Suchfunktion zu
        finden.
      </React.Fragment>
      <br />
    </MError>
  </Layout>
)

export default NotFoundPage
